const TermsAndConditions = () => {
  window.location.href = 'https://storage.googleapis.com/relif-public-bucket/terms_and_conditions.pdf';
  return null;
};

export default TermsAndConditions;
